import React from "react";
import { Link } from "react-router-dom";
import { HeroArt, TrackBadge, TagChip } from "./bits";
import { WinnerBadge } from "./winners/WinnerBadge";
import { SUPPORT_ENABLED } from "../lib/features";
import { PlayCircle } from "lucide-react";
import { cardTags } from "../lib/tagMeta";

export default function ProjectGridCard({ project }) {
  const tags = cardTags(project.u_tags).slice(0, 3);
  return (
    <Link to={`/p/${project.slug}`} data-testid={`grid-card-${project.slug}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-white/5 ring-1 ring-white/10 transition-all hover:-translate-y-1 hover:ring-gold-500/40">
      <div className="relative aspect-video w-full">
        <HeroArt project={project} rounded="rounded-none" className="h-full w-full" />
        <div className="absolute left-2 top-2 flex flex-col items-start gap-1"><TrackBadge track={project.track} /><WinnerBadge slug={project.slug} /></div>
        <div className="absolute right-2 top-2 flex flex-col items-end gap-1">
          {project.video_url && <span className="inline-flex items-center gap-1 rounded-pill bg-navy-900/75 px-1.5 py-0.5 text-[10px] font-bold text-white backdrop-blur"><PlayCircle size={10} /> Video</span>}
          {project.backed && SUPPORT_ENABLED && <span className="rounded-pill bg-candy-500/90 px-1.5 py-0.5 text-[10px] font-bold text-white backdrop-blur">Backed 💛</span>}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-1 p-3">
        <h3 className="font-display text-[17px] font-bold leading-tight text-white line-clamp-1">{project.project}</h3>
        <p className="truncate text-[12px] text-on-dark-muted">by {project.team}</p>
        <p className="text-[13px] leading-snug text-white/80 line-clamp-2">{project.one_liner}</p>
        <div className="mt-auto flex flex-wrap gap-1 pt-2">
          {tags.map((t) => <TagChip key={t} tag={t} size="sm" />)}
        </div>
      </div>
    </Link>
  );
}
